// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: 8p50CBe8Ah
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicProjectCreation.module.css"; // plasmic-import: 8p50CBe8Ah/css

import FileSvgrepoComsvgIcon from "./icons/PlasmicIcon__FileSvgrepoComsvg"; // plasmic-import: ti9TN1ijP8/icon
import PlusSvgrepoCom2SvgIcon from "./icons/PlasmicIcon__PlusSvgrepoCom2Svg"; // plasmic-import: nKIBWscm2V/icon

export type PlasmicProjectCreation__VariantMembers = {};

export type PlasmicProjectCreation__VariantsArgs = {};
type VariantPropType = keyof PlasmicProjectCreation__VariantsArgs;
export const PlasmicProjectCreation__VariantProps =
  new Array<VariantPropType>();

export type PlasmicProjectCreation__ArgsType = {};
type ArgPropType = keyof PlasmicProjectCreation__ArgsType;
export const PlasmicProjectCreation__ArgProps = new Array<ArgPropType>();

export type PlasmicProjectCreation__OverridesType = {
  root?: p.Flex<"div">;
  text?: p.Flex<"div">;
};

export interface DefaultProjectCreationProps {
  className?: string;
}

function PlasmicProjectCreation__RenderFunc(props: {
  variants: PlasmicProjectCreation__VariantsArgs;
  args: PlasmicProjectCreation__ArgsType;
  overrides: PlasmicProjectCreation__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__gTubp)}>
        <FileSvgrepoComsvgIcon
          className={classNames(projectcss.all, sty.svg__nkmDo)}
          role={"img"}
        />

        <div className={classNames(projectcss.all, sty.freeBox__oNh4A)}>
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text
            )}
          >
            {"New Project"}
          </div>
        </div>

        <PlusSvgrepoCom2SvgIcon
          className={classNames(projectcss.all, sty.svg___41IvM)}
          role={"img"}
        />
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "text"],
  text: ["text"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  text: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicProjectCreation__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicProjectCreation__VariantsArgs;
    args?: PlasmicProjectCreation__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicProjectCreation__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicProjectCreation__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicProjectCreation__ArgProps,
          internalVariantPropNames: PlasmicProjectCreation__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicProjectCreation__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicProjectCreation";
  } else {
    func.displayName = `PlasmicProjectCreation.${nodeName}`;
  }
  return func;
}

export const PlasmicProjectCreation = Object.assign(
  // Top-level PlasmicProjectCreation renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),

    // Metadata about props expected for PlasmicProjectCreation
    internalVariantProps: PlasmicProjectCreation__VariantProps,
    internalArgProps: PlasmicProjectCreation__ArgProps
  }
);

export default PlasmicProjectCreation;
/* prettier-ignore-end */
